<h1>Tell us about your business</h1>
<p>Set up your business entity to simplify your business operations in Hospitable.</p>
<sbnb-business-form></sbnb-business-form>
